import React, { ReactNode } from 'react';
import { Typography } from '../../../../../wag-react/components/Typography';
import { Box, BoxProps } from '../../../../../wag-react/next-components/box';
type Props = {
  children?: ReactNode;
  title?: string | ReactNode;
  text?: string;
  containerProps?: BoxProps;
  contentProps?: BoxProps;
  titleProps?: BoxProps;
  isFetchingData?: boolean;
};
export const WalkerSectionContainer = ({
  children,
  title,
  text,
  isFetchingData = false,
  containerProps,
  contentProps,
  titleProps
}: Props) => <Box display="flex" flexWrap="wrap" justifyContent="space-between" py={[3]} opacity={isFetchingData ? 0.5 : 1} style={{
  rowGap: '12px'
}} {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerSectionContainer" data-sentry-source-file="WalkerSectionContainer.tsx">
    {title && <Typography fontSize={['16px', '18px']} variant="h4" fontFamily="muliBold" color="#272727" width="100%" m={0} pb={1} {...titleProps}>
        {title}
      </Typography>}
    {text && <Typography color="#272727" variant="body1" m={0} fontFamily="muli" fontSize={['14px']} lineHeight={['1.6em', null, '1.8em']} style={{
    wordBreak: 'break-word'
  }} {...contentProps}>
        {text}
      </Typography>}
    {children}
  </Box>;